<div class="pin-container">
  <div class="bvdc-header">
    <span class="bvdc-title">{{
      forgotPin ? "Forgot PIN Code?" : dialogTitle
    }}</span>
    <button
      class="close-button"
      type="button"
      tabindex="-1"
      mat-icon-button
      mat-dialog-close
      aria-label="Close"
      *ngIf="!forgotPin"
    >
      <mat-icon class="notranslate">clear</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <div
      class="pin-code-dialog-content"
      [class.pin-container-non-visible]="forgotPin"
    >
      <div class="pin-code-dialog-content-upper-section">
        <form id="cc-form">
          <ng-container *ngFor="let fieldKey of Object.keys(fields)">
            <div
              class="inner-container"
              *ngIf="data.unitCardPinAction == fieldKey"
            >
              <div class="form-group" *ngFor="let field of fields[fieldKey]">
                <div [class]="field.labelContainerClass">
                  <label [for]="field.class">{{ field.label }}</label>
                  <span
                    *ngIf="
                      field.labelContainerClass === 'old-pin-label-container'
                    "
                    class="forgot-pin-text"
                    (click)="forgotPin = true"
                    >Forgot PIN?</span
                  >
                </div>

                <span [id]="field.class" class="form-field">
                  <!--VGS Collect iframe for PIN field will be here!-->
                </span>
                <span *ngIf="state$ | async as state">
                  <mat-error
                    *ngIf="
                      (!state[field?.vcsFieldDefinition?.definition?.name]
                        ?.isValid &&
                        state[field?.vcsFieldDefinition?.definition?.name]
                          ?.isTouched &&
                        !state[field?.vcsFieldDefinition?.definition?.name]
                          ?.isFocused) ||
                      showAllErrors
                    "
                    >{{
                      errors[
                        state[field.vcsFieldDefinition.definition.name]
                          .errorMessages[0]
                      ]
                    }}</mat-error
                  >
                </span>
              </div>
            </div>
          </ng-container>
        </form>
        <terra-unit-card
          [cardStatus]="data.businessVirtualDebitCard.cardStatus"
          [cardId]="data.businessVirtualDebitCard.id"
          [holderFullName]="data.businessVirtualDebitCard.fullName"
          [cardNumber]="data.businessVirtualDebitCard.last4Digits"
          [exp]="data.businessVirtualDebitCard.expirationDate"
          [viewSensitive]="false"
          [loadingSensitiveData]="false"
        >
        </terra-unit-card>
      </div>

      <div
        class="warning-message"
        *ngIf="data.unitCardPinAction === UnitCardPinAction.SET_PIN"
      >
        <div class="warning-message-icon">
          <mat-icon>info_outline</mat-icon>
        </div>
        <div class="warning-message-text">
          <p>
            YOU ARE RESPONSIBLE FOR SAFEKEEPING YOUR PIN. DO NOT DISCLOSE OR
            MAKE YOUR PIN AVAILABLE TO ANYONE NOT AUTHORIZED TO SIGN ON YOUR
            ACCOUNT.
          </p>
          <p>
            Remember to securely save your PIN code as it's your key to secure
            transactions. Losing it may require additional steps for recovery,
            so keep it safe for uninterrupted access.
          </p>
        </div>
      </div>
    </div>
    <ng-container *ngIf="forgotPin">
      <div class="forgot-pin-container">
        <div class="flex flex-column align-items-center gap-4">
          <div class="flex flex-column gap-4 align-items-center">
            <img
              class="restore-pin-code-img"
              src="/assets/images/icons/unit-card/restore-pin-code.svg"
            />
            <span class="text-center line-height-2 text-xl font-bold"
              >To restore your old PIN Code</span
            >
          </div>
          <div class="flex flex-column align-items-center">
            <span class="text-center">Please call this toll-free number: </span>
            <span
              class="text-center font-bold text-primary-new line-height-3 text-xl"
              >1-833-9712109
            </span>
            <span class="text-center"
              >(9 am - 5 pm, eastern time, Mon - Fri)</span
            >
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="right-action-buttons" mat-dialog-actions *ngIf="!forgotPin">
    <mat-error *ngIf="responseError$ | async as error">{{
      errors[error] ? errors[error] : error
    }}</mat-error>
    <button mat-flat-button mat-dialog-close id="submit-pin">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      id="submit-pin"
      (click)="submitPin()"
    >
      {{
        data.unitCardPinAction === UnitCardPinAction.SET_PIN
          ? "Save PIN Code"
          : "Reset PIN Code"
      }}
    </button>
  </div>
  <div class="center-action-buttons" mat-dialog-actions *ngIf="forgotPin">
    <button
      mat-flat-button
      color="primary"
      id="submit-pin"
      (click)="forgotPin = false"
    >
      Back to Reset PIN Code
    </button>
  </div>
</div>
